const Skeleton = ({ className }: { className?: string }) => (
  <div className={`animate-pulse bg-muted rounded-md ${className}`} />
);

export const GeneralInfoSkeleton = ({
  className,
  v,
}: {
  className?: string;
  v?: string;
}) => {
  if (v === "2.0") {
    return (
      <div className={`bg-background p-4 space-y-5 ${className}`}>
        {/* Hero */}
        <div className="relative overflow-hidden rounded-2xl border shadow">
          {/* Background blur placeholder */}
          <Skeleton className="absolute inset-0 !rounded-none opacity-30" />

          <div className="relative flex items-start gap-5 p-3">
            {/* Logo */}
            <Skeleton className="w-[160px] h-[160px] !rounded-2xl border flex-shrink-0" />

            <div className="flex-1 min-w-0 flex flex-col gap-4">
              {/* Header */}
              <div className="flex items-center justify-between">
                <Skeleton className="h-7 w-72 rounded-md" />
                <Skeleton className="h-8 w-8 rounded-lg" />
              </div>

              {/* Metadata badges */}
              <div className="flex flex-wrap gap-4">
                <Skeleton className="h-10 w-32 rounded-md" />
                <Skeleton className="h-10 w-24 rounded-md" />
                <Skeleton className="h-10 w-28 rounded-md" />
              </div>

              {/* Tags */}
              <div className="space-y-2 pt-2">
                <Skeleton className="h-3 w-10 rounded" />

                <div className="flex gap-2 flex-wrap">
                  <Skeleton className="h-6 w-16 !rounded-full" />
                  <Skeleton className="h-6 w-20 !rounded-full" />
                  <Skeleton className="h-6 w-14 !rounded-full" />
                  <Skeleton className="h-6 w-24 !rounded-full" />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Meta cards */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {[...Array(4)].map((_, i) => (
            <div
              key={i}
              className="border border-muted rounded-xl shadow p-3 space-y-3"
            >
              <div className="flex items-center gap-2">
                <Skeleton className="h-5 w-5 rounded" />
                <Skeleton className="h-3 w-24 rounded" />
              </div>

              {i === 2 || i === 3 ? (
                <div className="flex flex-wrap gap-2">
                  <Skeleton className="h-5 w-14 rounded-md" />
                  <Skeleton className="h-5 w-16 rounded-md" />
                  <Skeleton className="h-5 w-12 rounded-md" />
                </div>
              ) : (
                <Skeleton className="h-5 w-20 rounded" />
              )}
            </div>
          ))}
        </div>

        {/* Description cards */}
        <div className="grid md:grid-cols-2 gap-3">
          {[0, 1].map((i) => (
            <div key={i} className="bg-muted rounded-xl p-4 space-y-4">
              <div className="flex items-center gap-2 border-b pb-2">
                <Skeleton className="h-4 w-4 rounded" />
                <Skeleton
                  className={`h-4 ${i === 0 ? "w-40" : "w-44"} rounded`}
                />
              </div>

              <div className="space-y-2">
                <Skeleton className="h-4 w-full rounded" />
                <Skeleton className="h-4 w-11/12 rounded" />
                <Skeleton className="h-4 w-full rounded" />
                <Skeleton className="h-4 w-10/12 rounded" />
                <Skeleton className="h-4 w-8/12 rounded" />
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  // v1
  return (
    <div
      className={`bg-background rounded-lg shadow-sm p-6 space-y-5 ${className}`}
    >
      <div className="flex gap-5">
        <Skeleton className="w-[150px] h-[150px] rounded-xl" />
        <div className="flex-1 space-y-4">
          <div className="flex justify-between items-center">
            <Skeleton className="h-7 w-[320px]" />
            <Skeleton className="h-7 w-10" />
          </div>
          <div className="flex gap-3">
            <Skeleton className="h-10 w-36" />
            <Skeleton className="h-10 w-20" />
            <Skeleton className="h-10 w-28" />
          </div>
          <div className="flex flex-col gap-2">
            <Skeleton className="h-5 w-8" />
            <div className="flex gap-2">
              <Skeleton className="h-7 w-16 !rounded-full" />
              <Skeleton className="h-7 w-20 !rounded-full" />
              <Skeleton className="h-7 w-12 !rounded-full" />
            </div>
          </div>
        </div>
      </div>
      <div className="flex gap-6 !mt-6">
        <Skeleton className="h-10 w-36" />
        <Skeleton className="h-10 w-36" />
        <Skeleton className="h-10 w-36" />
        <Skeleton className="h-10 w-36" />
      </div>
      <div className="flex items-center gap-5 !mt-7">
        <Skeleton className="h-36 w-full flex-1" />
        <Skeleton className="h-36 w-full flex-1" />
      </div>
    </div>
  );
};
